export const GET_CAMPAIGN_DATA = 'campaign/GET_CAMPAIGN_DATA';
export const GET_CAMPAIGN_DATA_SUCCESS = 'campaign/GET_CAMPAIGN_DATA_SUCCESS';
export const GET_CAMPAIGN_DATA_FAIL = 'campaign/GET_CAMPAIGN_DATA_FAIL';



// WEBPACK FOOTER //
// ./src/redux/constants/campaigns.js